var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circularButton"},[_c('div',{staticClass:"inside",style:({ background: _vm.background })},[_c('i',{class:_vm.icon,style:({ color: _vm.color })})]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }